import React, { FC, memo } from 'react'
import { Banner } from '@getgo/chameleon-web-react-wrapper'
import { Box, makeStyles } from '@material-ui/core'

import { Banners } from 'components'
import { GlobalBanner } from 'hooks'

interface AdminBannersProps {
  banners: GlobalBanner[]
  removeBanner: (key) => void
}

const useStyles = makeStyles(() => ({
  bannerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
  },
}))

const AdminBanners: FC<AdminBannersProps> = ({ banners, removeBanner }) => {
  const classes = useStyles()

  return (
    <Box className={classes.bannerContainer}>
      <Banners>
        {banners
          .sort((a, b) => b.createdAt - a.createdAt)
          .map(({ id, content, closeable, variant = 'neutral' }) => (
            <Banner key={id} variant={variant} closable={closeable} onClose={() => removeBanner(id)}>
              {content}
            </Banner>
          ))}
      </Banners>
    </Box>
  )
}

export default memo(AdminBanners)
